import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  TrainingsCategory,
  buildTrainingsDataTableFilter,
  useTrainingsDataTable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const categoriesFilter = (
  source: ReturnType<typeof useTrainingsDataTable>,
  categories: TrainingsCategory[] | undefined
) => {
  const options = categories
    ? categories?.map((category) => {
        return {
          label: category.name,
          value: category.id,
          component: (
            <Box flexDirection="row" alignItems="center" gap="s8">
              <Text.Normal weight="medium">{category.name}</Text.Normal>
            </Box>
          ),
        }
      })
    : []

  return buildTrainingsDataTableFilter(source, {
    type: FilterType.Integer,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'trainingCategoriesFilter',
    path: 'categoryId',
    title: i18n.t('trainings.trainings_table.tags'),
    onUpdateValue: () => {
      track(trackingEvents.training.trainingsFilters.tagsFilter)
    },
  })
}
